import { render } from "./ServeMe.vue?vue&type=template&id=b65ca2b8"
import script from "./ServeMe.vue?vue&type=script&lang=js"
export * from "./ServeMe.vue?vue&type=script&lang=js"

import "./ServeMe.vue?vue&type=style&index=0&id=b65ca2b8&lang=scss"

import exportComponent from "/builds/root/lvgou_pub_mob/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__